// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Expln_React_Row = require("@expln/utils/src/main/react-mui-components/Expln_React_Row.bs.js");
var Expln_React_common = require("@expln/utils/src/main/Expln_React_common.bs.js");
var Expln_utils_common = require("@expln/utils/src/main/Expln_utils_common.bs.js");
var Select = require("@mui/material/Select").default;
var MenuItem = require("@mui/material/MenuItem").default;
var InputLabel = require("@mui/material/InputLabel").default;
var FormControl = require("@mui/material/FormControl").default;

function strToBool(str) {
  switch (str) {
    case "false" :
        return false;
    case "true" :
        return true;
    default:
      return true;
  }
}

var boolToStr = Expln_utils_common.stringify;

function MM_cmp_edit_stmts_setting(props) {
  var onChange = props.onChange;
  var editStmtsByLeftClick = props.editStmtsByLeftClick;
  return React.createElement(Expln_React_Row.make, {
              alignItems: "center",
              children: Caml_option.some(null)
            }, React.createElement(FormControl, {
                  size: "small",
                  children: Caml_option.some(null)
                }, React.createElement(InputLabel, {
                      id: "label-for-edit-statements-by",
                      children: "Edit statements by"
                    }), React.createElement(Select, {
                      sx: {
                        width: 150
                      },
                      labelId: "label-for-edit-statements-by",
                      label: "Edit statements by",
                      value: Expln_utils_common.stringify(editStmtsByLeftClick),
                      onChange: (function (param) {
                          return Expln_React_common.evt2str((function (boolStr) {
                                        Curry._1(onChange, strToBool(boolStr));
                                      }), param);
                        }),
                      children: Caml_option.some(null)
                    }, React.createElement(MenuItem, {
                          value: "true",
                          children: "Left click"
                        }), React.createElement(MenuItem, {
                          value: "false",
                          children: "Alt + Left click"
                        }))), React.createElement(FormControl, {
                  size: "small",
                  children: Caml_option.some(null)
                }, React.createElement(InputLabel, {
                      id: "label-for-select-statements-by",
                      children: "Select statements by"
                    }), React.createElement(Select, {
                      sx: {
                        width: 150
                      },
                      labelId: "label-for-select-statements-by",
                      label: "Select statements by",
                      value: Expln_utils_common.stringify(!editStmtsByLeftClick),
                      onChange: (function (param) {
                          return Expln_React_common.evt2str((function (boolStr) {
                                        Curry._1(onChange, !strToBool(boolStr));
                                      }), param);
                        }),
                      children: Caml_option.some(null)
                    }, React.createElement(MenuItem, {
                          value: "true",
                          children: "Left click"
                        }), React.createElement(MenuItem, {
                          value: "false",
                          children: "Alt + Left click"
                        }))));
}

var make = MM_cmp_edit_stmts_setting;

exports.strToBool = strToBool;
exports.boolToStr = boolToStr;
exports.make = make;
/* react Not a pure module */
